// src/main.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import "./i18n.js";
import "./index.css";
// import * as Sentry from "@sentry/react";
import App from "./App";

// --- Detecta dominio y elige DSN ---
// const HOST = window.location.hostname;
// const isProdSey = HOST === "knowledgebase.excent.capital";
// const isProdSvg = HOST === "knowledgebase.excentcapital.com";
// const isDemoEnv = HOST === "knowledgebase.demo.excent.capital";

// const DSN = isProdSey
//   ? import.meta.env.VITE_SENTRY_DSN_SEY
//   : isProdSvg
//     ? import.meta.env.VITE_SENTRY_DSN_SVG
//     : isDemoEnv
//       ? import.meta.env.VITE_SENTRY_DSN_DEMO
//       : undefined;

// // Solo inicializa si hay DSN (prod real)
// if (DSN) {
//   Sentry.init({
//     dsn: DSN,
//     sendDefaultPii: true,
//     integrations: [
//       Sentry.browserTracingIntegration(),
//       Sentry.replayIntegration(),
//     ],

//     // APM / Replay (ajusta o deja así)
//     tracesSampleRate: 0.1,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//     release: "1.8.2",
//     // Propagación de trazas solo a tus frontends de knowledgebase
//     tracePropagationTargets: [
//       /^https:\/\/knowledgebase\.excent\.capital/i,
//       /^https:\/\/knowledgebase\.excentcapital\.com/i,
//       /^https:\/\/knowledgebase\.demo\.excent\.capital/i,
//     ],

//     // Filtro básico para ruido común
//     beforeSend(event) {
//       const msg = (event?.exception?.values?.[0]?.value || "").toString();
//       if (
//         /ResizeObserver loop limit exceeded/i.test(msg) ||
//         /Network Error/i.test(msg) ||
//         /Request aborted/i.test(msg) ||
//         /chrome-extension:\/\//i.test(JSON.stringify(event))
//       ) {
//         return null;
//       }
//       return event;
//     },
//   });
// }

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
